import React from 'react';
import { useMediaQuery } from 'react-responsive';
import OnlineStoreContent from './OnlineStoreContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <OnlineStoreContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
